import type { FaireProductEntity } from "../../entity_types/product";

export const p_2dtqnev25t: FaireProductEntity = {
  token: "p_2dtqnev25t",
  type: "product",
  name: "Wind River Meditation Chime - Large - Wholesale",
  brandToken: "b_8z7zv9rr",
  brandName: "Wind River",
  imageUrl:
    "https://cdn.faire.com/fastly/13090354b8872486ef2ec02d0614c68f2facfbaa6aa1baceae60cb5ce7d7e489.jpeg",
  galleryImageUrls: [],
  priceDollars: 63.93,
  description:
    'Find a moment to breathe, relax and reset with a Wind River meditation chime. The soothing tones of Wind River chimes are now available indoors - no matter where you live or what today’s weather brings. Strike a note to pause, regroup and appreciate life, one moment and at a time.\n\nWind River meditation chimes are available in two introductory sizes, tuned to match the longest and shortest of our popular Corinthian Bells 50" Wind Chime.\n\n\nSmall tube length is 19.25"\n\nLarge tube length is 27.75"\n\n\n',
  tags: [],
  msrpDollars: 134.25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:26.932Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
